import cn from "classnames";
import "./LoadingOverlay.scss";
import { Spinner } from "/App.Components";
interface LoadingOverlay {
  loading: boolean;
  hasSpinner?: boolean;
}

const LoadingOverlay = ({ loading, hasSpinner = true }: LoadingOverlay) => (
  <div
    className={cn("loading-overlay-norad", {
      "loading-overlay-norad--active": loading,
    })}
  >
    {hasSpinner && <Spinner />}
  </div>
);

export default LoadingOverlay;
